import { IpaType, getFeaturesForOne, ipaToFeatures } from "../phonemes/ipa";
import { segmentPhonemes } from "../phonemes/segmentPhonemes";
import { getPossibleCombos } from "../phonemes/getPossibleCombos";

/** convert all of /ipa/'s features to a string */
export function getFeatureString(ipa: IpaType): string {
  if (ipa === '•') {
    return '';
  }

  // e.g., turn /kp/ into /k͡p/ so we can lookup its features
  ipa = possiblyAddTie(ipa);

  // first see if the symbol(s) are simply one of the items in ipaFeatures
  const features = getFeaturesForOne(ipa);
  if (features !== undefined && features.length > 0) {
    // e.g., for /a/, /cç/, /kp/
    return features.join(', ');
  }

  // get features per segment
  const segmented = segmentPhonemes(ipa, 'ipa', 'all-aff');
  const listOfLists = segmented.phonemes.map(seg => {
    const f = ipaToFeatures(seg.phoneme);
    return f ?? [];
  });

  if (listOfLists.length === 1) {
    // e.g., for /ŋ̩/, /kʰ/
    return listOfLists[0].join(', ');
  }

  // e.g., for /mb/, /kǃʰ/
  //  [consonant, pulmonic, plosive, velar, voiced] [consonant, non-pulmonic, click, dental]
  const t = listOfLists.map(list => '[' + list.join(', ') + ']');
  return t.join(' ');
}

/** see if a version with a tie exists in the list of IPA & return that if so */
function possiblyAddTie(ipa: IpaType): IpaType {
  const segmented = segmentPhonemes(ipa, 'ipa', 'all-aff');
  if (segmented.phonemes.length < 2) {
    return ipa;
  }

  const combo = getPossibleCombos(segmented.phonemes);
  if (combo.length !== 1) {
    return ipa;
  }

  return combo[0][1];
}
